import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { InteractionType, LocalService, Wrappers10, TriggeredEvent, GeneralConfigType, KeyValueSet, PageKey, Wrapper10Initialization } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';
import { NewComplaintComponent } from '../../popups/new-complaint/new-complaint.component';

@Component({
  selector: 'app-complaints',
  templateUrl: './complaints.component.html',
  styleUrls: ['./complaints.component.scss']
})
export class ComplaintsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["complaints"]; userId = ''; interactionType: InteractionType = InteractionType.None; ctryCode: string = '';
  logId = ''; source: Wrapper10Initialization; isForCustomer = true; maxBodyHeight = 0; statuses: KeyValueSet[]; selectedStatus = ''; filterStatus = '';
  isShowOnlyOwnLoginAssigned = false; detailsCountryCode = '';
  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private route: ActivatedRoute, private modalService: NgbModal, private profileManagementService: ProfileManagementService, private cdr: ChangeDetectorRef, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.ComplaintStatus).subscribe(result => {
      this.statuses = result;
    });
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      this.configurationManagementService.ensurePageActions(this.interactionType == InteractionType.Bill_PnixSoft ? PageKey.FeedbackAdmin : PageKey.Feedback);
      this.logId = routeParams.logId;
      if (this.logId == '0')
        this.logId = '';
      this.isForCustomer = this.interactionType == InteractionType.User;
      if (this.logId == '')
        this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      if (this.source && this.source.content) {
        this.source.content = null;
      }
      this.onLoad(true);
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad(isResetAll = false) {
    if (this.logId == '') {
      if (!this.source || isResetAll) {
        this.profileManagementService.getComplaintsInitialization(this.isForCustomer, this.filterStatus, this.isShowOnlyOwnLoginAssigned).subscribe(result => {
          this.source = result;
          this.detailsCountryCode = this.isForCustomer ? this.ctryCode : this.source.locations.selected.key;
        });
      } else {
        this.profileManagementService.getComplaints(this.isForCustomer, this.source.content.paging, this.isForCustomer ? null : this.source.locations.selected, this.filterStatus, this.isShowOnlyOwnLoginAssigned).subscribe(result => {
          this.source.content = result;
          this.detailsCountryCode = this.isForCustomer ? this.ctryCode : this.source.locations.selected.key;
        });
      }
    } else {
      this.profileManagementService.getComplaintStatus(this.logId, this.detailsCountryCode).subscribe(result => {
        this.selectedStatus = result.id;
      });
      this.profileManagementService.getComplaintDetails(this.logId, this.detailsCountryCode).subscribe(result => {
        this.source = {
          content: { items: result } as Wrappers10
        } as Wrapper10Initialization;
      });
    }
  }

  onAction(index) {
    switch (index) {
      case 1: {
        const modalRef = this.modalService.open(NewComplaintComponent);
        modalRef.componentInstance.interactionType = this.interactionType;
        modalRef.componentInstance.logId = this.logId;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            this.onLoad();
          }
        });
      } break;
      case 2: {
        if (this.selectedStatus && this.selectedStatus != '') {
          this.profileManagementService.updateComplaintStatus(this.logId, this.detailsCountryCode, parseInt(this.selectedStatus)).subscribe(result => {
            this.localService.showInformationByStatus(result.status);
          });
        }
      } break;
    }
  }

  onCountryUpdated(e) {
    this.source.locations.selected.key = e;
  }
}
